<template>
  <div>
    <div class="row phone-row" style="margin-bottom: 0 !important;" v-if="backspace">
      <div class="number col-10" style="min-height: 2.5em;">
        <span v-if="number.length < 12">{{ number === `DEVCONF${username}` ? $t('keypad.conferenceCall') : (number === '9999999' ? 'Voicemail' : number) }}</span>
        <span style="font-size: 1.4rem !important;" v-else>{{ number.substring(number.length - 16, number.length) }}</span>
      </div>
      <div class="col-2" style="min-height: 2.5em;">
        <div class="dig" v-if="number.length > 0">
          <i class="mdi mdi-backspace"  @mouseup="mouseupBackspace" @mousedown="mousedownBackspace" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="row phone-row" style="margin-bottom: 0 !important;" v-else>
      <div class="number col-10" style="min-height: 2.5em;">
        <span v-if="number.length < 12">{{ number === `DEVCONF${username}` ? $t('keypad.conferenceCall') : (number === '9999999' ? 'Voicemail' : number) }}</span>
        <span style="font-size: 1.4rem !important;" v-else>{{ number.substring(number.length - 16, number.length) }}</span>
      </div>
      <div class="number col-1" style="min-height: 2.5em; color: grey !important; cursor: pointer;" @click="clear" v-if="number.length > 0">
        <i class="mdi mdi-close" aria-hidden="true"></i>
      </div>
    </div>
    <div class="row phone-row" style="margin-top: 0 !important;">
      <div class="col-12">
        {{ hangupCause !== '' && hangupCause !== 'NORMAL_CLEARING' ? hangupCause : '&nbsp;' }}
      </div>
    </div>
    <div class="row phone-row">
      <div class="col-4 dig" id="one" @click="digit('1')">1</div>
      <div class="col-4 dig" id="two" @click="digit('2')">2
        <div class="sub">ABC</div>
      </div>
      <div class="col-4 dig" id="three" @click="digit('3')">3
        <div class="sub">DEF</div>
      </div>
    </div>
    <div class="row phone-row">
      <div class="col-4 dig" id="four" @click="digit('4')">4
        <div class="sub">GHI</div>
      </div>
      <div class="col-4 dig" id="five" @click="digit('5')">5
        <div class="sub">JKL</div>
      </div>
      <div class="col-4 dig" id="six" @click="digit('6')">6
        <div class="sub">MNO</div>
      </div>
    </div>
    <div class="row phone-row">
      <div class="col-4 dig" id="seven" @click="digit('7')">7
        <div class="sub">PQRS</div>
      </div>
      <div class="col-4 dig" id="eight" @click="digit('8')">8
        <div class="sub">TUV</div>
      </div>
      <div class="col-4 dig" id="nine" @click="digit('9')">9
        <div class="sub">WXYZ</div>
      </div>
    </div>
    <div class="row phone-row">
      <div class="col-4 dig" id="star" @click="digit('*')">
        <i class="mdi mdi-asterisk" aria-hidden="true"></i>
      </div>
      <div class="col-4 dig" id="zero" @mouseup="mouseup" @mousedown="mousedown">0
        <div class="sub"><i class="mdi mdi-plus" aria-hidden="true"></i></div>
      </div>
      <div class="col-4 dig" id="hash" @click="digit('#')">
        <i class="mdi mdi-pound" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'keypad',
  props: {
    username: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: '',
      zeroPressed: false
    },
    numberName: {
      type: String,
      default: 'number'
    },
    digit: {
      type: Function
    },
    clear: {
      type: Function
    },
    backspace: {
      type: Function
    },
    hangupCause: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      zeroPressed: false,
      backspacePressed: false
    }
  },
  methods: {
    mousedown () {
      var self = this
      self.zeroPressed = true
      setTimeout(() => {
        if (self.zeroPressed) {
          self.digit('+')
          self.zeroPressed = false
        }
      }, 1000)
    },
    mouseup () {
      var self = this
      if (self.zeroPressed) {
        self.digit('0')
        self.zeroPressed = false
      }
    },
    mousedownBackspace () {
      var self = this
      self.backspacePressed = true
      setTimeout(() => {
        if (self.backspacePressed) {
          self.clear()
          self.backspacePressed = false
        }
      }, 1000)
    },
    mouseupBackspace () {
      var self = this
      if (self.backspacePressed) {
        self.backspace()
        self.backspacePressed = false
      }
    }
  }
}

</script>

<style scoped>

.number {
  padding: 10px 10px;
  width: 100%;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: transparent;
  text-shadow: 0 0 0 #1976d2;
}

.digit,
.dig {
  cursor: pointer;
  font-size: 1.5em;
}

.digit:active,
.dig:active {
  background-color: #e6e6e6;
}

.sub {
  font-size: 0.8rem;
  color: grey;
}

.output {
  font-family: "Exo";
  font-size: 2rem;
  height: 60px;
  width: 90%;
  font-weight: bold;
  border: 0;
  outline-width: 0;
  text-align: center;
  color: transparent;
  text-shadow: 0 0 0 #1976d2;
}

.btn.btn-rounded {
  border-radius: 10px;
  color: #ffffff;
  width: 100%;
  height: 42px;
  cursor: pointer;
}

.phone-row {
  margin: 20px auto !important;
  max-width: 320px !important;
  clear: both !important;
  text-align: center !important;
}

</style>
